import _ from 'lodash';
import utilities from '@/services/utilities/utilities';
import helpers from '@/services/simulator/get-info-from-combined-cards/helpers';
import constants from '@/services/constants';

export default {
  run: function (cards) {
    let handInfo = {
      id: null,
      name: null,
      value: null,
      handCards: null
    };
    let cardsByRank = helpers.getCardsByRank(cards);
    let fiveOrMoreCardsInARowResult = this._checkForFiveOrMoreCardsInARow(cards);
    let fiveOrMoreCardsOfSameSuitResult = this._checkForFiveOrMoreCardsOfSameSuit(cards);

    this._checkForRoyalFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    if (!handInfo.name) {
      this._checkForStraightFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFourOfAKind(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFullHouse(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForStraight(fiveOrMoreCardsInARowResult, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForThreeOfAKind(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForTwoPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForHighCard(cards, handInfo);
    }

    return handInfo;
  },
  _checkForFiveOrMoreCardsOfSameSuit: function (cards) {
    if (cards.length < 5) {
      return false;
    }

    let toReturn = false;
    let cardsBySuit = helpers.getCardsBySuit(cards);

    _.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length >= 5) {
        toReturn = {
          suit: suit,
          cards: cardsOfSuit
        };
      }
    });

    return toReturn;
  },
  _checkForFiveOrMoreCardsInARow: function (cards) {
    let ranks = utilities.ranks.getRanksFromCards(cards);
    return this._checkForFiveOrMoreRanksInARow(ranks);
  },
  _checkForFiveOrMoreRanksInARow: function (ranks) {
    if (ranks.length < 5) {
      return false;
    }

    let fiveRankIndexes;
    let rankIndexes = utilities.ranks.getRankIndexesFromRanks(ranks, true);

    for (let i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (helpers.checkIfRankIndexesAreSequential(fiveRankIndexes)) {
        return {
          highCardRank: constants.ranks[fiveRankIndexes[0]]
        };
      }
    }

    return false;
  },
  _checkForRoyalFlush: function (fiveOrMoreCardsOfSameSuitResult, handInfo) {
    let straightWithFlushCardsResult;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARow(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank === 'a') {
        handInfo.id = 'fourOfAKindPlus:royalFlush';
        handInfo.name = 'royal flush';
        handInfo.value = 10;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = [
          'a' + handInfo.suit,
          'k' + handInfo.suit,
          'q' + handInfo.suit,
          'j' + handInfo.suit,
          't' + handInfo.suit
        ];
      }
    }
  },
  _checkForStraightFlush: function (fiveOrMoreCardsOfSameSuitResult, handInfo) {
    let straightWithFlushCardsResult;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARow(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank !== 'a') {
        handInfo.id = 'fourOfAKindPlus:straightFlush';
        handInfo.name = 'straight flush';
        handInfo.value = 9;
        handInfo.highCardRank = straightWithFlushCardsResult.highCardRank;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = [
          handInfo.highCardRank + handInfo.suit,
          utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 1) + handInfo.suit,
          utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 2) + handInfo.suit,
          utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 3) + handInfo.suit,
          utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 4) + handInfo.suit
        ];
      }
    }
  },
  _checkForFourOfAKind: function (cardsByRank, handInfo) {
    let nonFourOfAKindCards = [];

    _.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 4) {
        handInfo.id = 'fourOfAKindPlus:fourOfAKind';
        handInfo.name = 'four of a kind';
        handInfo.value = 8;
        handInfo.rank = rank;
      } else {
        cardsOfRank.forEach(function (card) {
          nonFourOfAKindCards.push(card);
        });
      }
    });

    if (handInfo.name === 'four of a kind') {
      handInfo.kicker = utilities.ranks.getHighestCardFromCards(nonFourOfAKindCards);
      handInfo.handCards = [
        handInfo.rank + 'c',
        handInfo.rank + 's',
        handInfo.rank + 'h',
        handInfo.rank + 'd',
        handInfo.kicker
      ];
    }
  },
  _checkForFullHouse: function (cardsByRank, handInfo) {
    let tripsCardGroups = [];
    let pairCardGroups = [];

    _.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 3) {
        tripsCardGroups.push(cardsOfRank);
      } else if (cardsOfRank.length === 2) {
        pairCardGroups.push(cardsOfRank);
      }
    });

    tripsCardGroups.sort(utilities.ranks.sortCardGroupsDescendingByRankCompareFunction);
    pairCardGroups.sort(utilities.ranks.sortCardGroupsDescendingByRankCompareFunction);

    if (tripsCardGroups.length === 2) {
      handInfo.id = 'fullHouse';
      handInfo.name = 'full house';
      handInfo.value = 7;
      handInfo.tripsRank = tripsCardGroups[0][0][0];
      handInfo.pairRank = tripsCardGroups[1][0][0];
      handInfo.handCards = [
        tripsCardGroups[0][0],
        tripsCardGroups[0][1],
        tripsCardGroups[0][2],
        tripsCardGroups[1][0],
        tripsCardGroups[1][1]
      ];
    }

    else if (tripsCardGroups.length === 1 && pairCardGroups.length >= 1) {
      handInfo.id = 'fullHouse';
      handInfo.name = 'full house';
      handInfo.value = 7;
      handInfo.tripsRank = tripsCardGroups[0][0][0];
      handInfo.pairRank = pairCardGroups[0][0][0];
      handInfo.handCards = [
        tripsCardGroups[0][0],
        tripsCardGroups[0][1],
        tripsCardGroups[0][2],
        pairCardGroups[0][0],
        pairCardGroups[0][1]
      ];
    }
  },
  _checkForFlush: function (fiveOrMoreCardsOfSameSuitResult, handInfo) {
    if (fiveOrMoreCardsOfSameSuitResult) {
      handInfo.name = 'flush';
      handInfo.value = 6;
      handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;

      fiveOrMoreCardsOfSameSuitResult.cards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
      handInfo.ranks = [
        fiveOrMoreCardsOfSameSuitResult.cards[0][0],
        fiveOrMoreCardsOfSameSuitResult.cards[1][0],
        fiveOrMoreCardsOfSameSuitResult.cards[2][0],
        fiveOrMoreCardsOfSameSuitResult.cards[3][0],
        fiveOrMoreCardsOfSameSuitResult.cards[4][0],
      ];
      handInfo.handCards = [
        fiveOrMoreCardsOfSameSuitResult.cards[0],
        fiveOrMoreCardsOfSameSuitResult.cards[1],
        fiveOrMoreCardsOfSameSuitResult.cards[2],
        fiveOrMoreCardsOfSameSuitResult.cards[3],
        fiveOrMoreCardsOfSameSuitResult.cards[4],
      ];
    }
  },
  _checkForStraight: function (fiveOrMoreCardsInARowResult, rawCards, handInfo) {
    let handCardHash;

    if (fiveOrMoreCardsInARowResult) {
      handInfo.id = 'straight';
      handInfo.name = 'straight';
      handInfo.value = 5;
      handInfo.highCardRank = fiveOrMoreCardsInARowResult.highCardRank;
      handCardHash = {};
      rawCards.forEach(function (card) {
        let cardRank = card[0];
        handCardHash[cardRank] = card;
      });
      handInfo.handCards = [
        handCardHash[handInfo.highCardRank],
        handCardHash[utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 1)],
        handCardHash[utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 2)],
        handCardHash[utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 3)],
        handCardHash[utilities.ranks.getRankNUnitsLower(handInfo.highCardRank, 4)]
      ];
    }
  },
  _checkForThreeOfAKind: function (cardsByRank, rawCards, handInfo) {
    _.forEach(cardsByRank, function (cardsOfRank, rank) {
      let sortedNonTripCards;

      if (cardsOfRank.length === 3) {
        handInfo.name = 'three of a kind';
        handInfo.value = 4;
        handInfo.rank = rank;
        handInfo.handCards = [];

        // get handCards
        cardsOfRank.forEach(function (card) {
          handInfo.handCards.push(card);
        });
        rawCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
        sortedNonTripCards = _.filter(rawCards, function (card) {
          let cardRank = card[0];
          return cardRank !== rank;
        });
        handInfo.kickers = [
          sortedNonTripCards[0], sortedNonTripCards[1]
        ];
        handInfo.handCards.push(handInfo.kickers[0]);
        handInfo.handCards.push(handInfo.kickers[1]);
      }
    });
  },
  _checkForTwoPair: function (cardsByRank, rawCards, handInfo) {
    let pairCardGroups = [];
    let nonHandCards;

    _.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 2) {
        pairCardGroups.push(cardsOfRank);
      }
    });
    pairCardGroups.sort(utilities.ranks.sortCardGroupsDescendingByRankCompareFunction);

    if (pairCardGroups.length >= 2) {
      handInfo.name = 'two pair';
      handInfo.value = 3;
      handInfo.higherPairRank = pairCardGroups[0][0][0];
      handInfo.lowerPairRank = pairCardGroups[1][0][0];
      handInfo.handCards = [];
      handInfo.handCards.push(pairCardGroups[0][0]);
      handInfo.handCards.push(pairCardGroups[0][1]);
      handInfo.handCards.push(pairCardGroups[1][0]);
      handInfo.handCards.push(pairCardGroups[1][1]);

      // get kicker
      nonHandCards = _.filter(rawCards, function (card) {
        return !handInfo.handCards.includes(card);
      });
      nonHandCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
      handInfo.kicker = nonHandCards[0];
      handInfo.handCards.push(handInfo.kicker);
    }
  },
  _checkForPair: function (cardsByRank, rawCards, handInfo) {
    let nonHandCards;

    _.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 2) {
        handInfo.name = 'pair';
        handInfo.value = 2;
        handInfo.rank = rank;
        handInfo.handCards = [];
        handInfo.handCards.push(cardsOfRank[0]);
        handInfo.handCards.push(cardsOfRank[1]);

        // get kickers
        nonHandCards = _.filter(rawCards, function (card) {
          return !handInfo.handCards.includes(card);
        });
        nonHandCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
        handInfo.kickers = [
          nonHandCards[0], nonHandCards[1], nonHandCards[2]
        ];
        handInfo.handCards.push(handInfo.kickers[0]);
        handInfo.handCards.push(handInfo.kickers[1]);
        handInfo.handCards.push(handInfo.kickers[2]);
      }
    });
  },
  _checkForHighCard: function (rawCards, handInfo) {
    handInfo.name = 'high card';
    handInfo.value = 1;
    rawCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
    handInfo.kickers = [
      rawCards[0], rawCards[1], rawCards[2], rawCards[3], rawCards[4]
    ];
    handInfo.handCards = [
      rawCards[0], rawCards[1], rawCards[2], rawCards[3], rawCards[4]
    ];
  },

  runForShortDeck: function (cards) {
    let handInfo = {
      id: null,
      name: null,
      value: null,
      handCards: null
    };
    let cardsByRank = helpers.getCardsByRank(cards);
    let fiveOrMoreCardsInARowResult = this._checkForFiveOrMoreCardsInARowShortDeck(cards);
    let fiveOrMoreCardsOfSameSuitResult = this._checkForFiveOrMoreCardsOfSameSuit(cards);

    this._checkForRoyalFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    if (!handInfo.name) {
      this._checkForStraightFlushShortDeck(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFourOfAKind(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);

      if (handInfo.name) {
        handInfo.value = 7;
      }
    }
    if (!handInfo.name) {
      this._checkForFullHouse(cardsByRank, handInfo);

      if (handInfo.name) {
        handInfo.value = 6;
      }
    }
    if (!handInfo.name) {
      this._checkForStraightShortDeck(fiveOrMoreCardsInARowResult, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForThreeOfAKind(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForTwoPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForHighCard(cards, handInfo);
    }

    return handInfo;
  },
  _checkForFiveOrMoreCardsInARowShortDeck: function (cards) {
    let ranks = utilities.ranks.getRanksFromCards(cards);
    return this._checkForFiveOrMoreRanksInARowShortDeck(ranks);
  },
  _checkForFiveOrMoreRanksInARowShortDeck: function (ranks) {
    if (ranks.length < 5) {
      return false;
    }

    let fiveRankIndexes;
    let rankIndexes = utilities.ranks.getRankIndexesFromRanksShortDeck(ranks, true);

    for (let i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (helpers.checkIfRankIndexesAreSequential(fiveRankIndexes)) {
        return {
          highCardRank: constants.ranks[fiveRankIndexes[0]]
        };
      }
    }

    return false;
  },
  _checkForStraightFlushShortDeck: function (fiveOrMoreCardsOfSameSuitResult, handInfo) {
    let straightWithFlushCardsResult;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARowShortDeck(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank !== 'a') {
        handInfo.id = 'fourOfAKindPlus:straightFlush';
        handInfo.name = 'straight flush';
        handInfo.value = 9;
        handInfo.highCardRank = straightWithFlushCardsResult.highCardRank;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = [
          handInfo.highCardRank + handInfo.suit,
          utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 1) + handInfo.suit,
          utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 2) + handInfo.suit,
          utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 3) + handInfo.suit,
          utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 4) + handInfo.suit
        ];
      }
    }
  },
  _checkForStraightShortDeck: function (fiveOrMoreCardsInARowResult, rawCards, handInfo) {
    let handCardHash;

    if (fiveOrMoreCardsInARowResult) {
      handInfo.id = 'straight';
      handInfo.name = 'straight';
      handInfo.value = 5;
      handInfo.highCardRank = fiveOrMoreCardsInARowResult.highCardRank;
      handCardHash = {};
      rawCards.forEach(function (card) {
        let cardRank = card[0];
        handCardHash[cardRank] = card;
      });
      handInfo.handCards = [
        handCardHash[handInfo.highCardRank],
        handCardHash[utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 1)],
        handCardHash[utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 2)],
        handCardHash[utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 3)],
        handCardHash[utilities.ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 4)]
      ];
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/get-info-from-combined-cards/get-hand-info.js